export default "__VITE_ASSET__a0DYBt4i__"